import type { DocumentReference, Reference } from '@medplum/fhirtypes'
import { invariant } from '@seen/core/invariant'
import { type JSX, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router'
import { DocumentReferenceDisplay } from '#src/components/document-reference/DocumentReferenceDisplay.tsx'

// onDelete replaces leaving the page once its document is deleted (an
// embedding host closes its own view).
export function DocumentReferencePage({
  onDelete,
}: {
  onDelete?: () => void
}): JSX.Element {
  const { documentId } = useParams<{ documentId: string }>()
  invariant(documentId, 'documentId is required')
  const navigate = useNavigate()

  const documentReference = useMemo<Reference<DocumentReference>>(
    () => ({ reference: `DocumentReference/${documentId}` }),
    [documentId]
  )

  return (
    <div className="p-4">
      <DocumentReferenceDisplay
        documentReference={documentReference}
        onDelete={onDelete ?? (() => navigate('..'))}
        hideParticipant
      />
    </div>
  )
}
